import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Popup, setOptions, Button, Checkbox, Textarea, Select, Input, confirm} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import {Listview, NavItem, TabNav} from '@mobiscroll/react4';
import '@mobiscroll/react4/dist/css/mobiscroll.min.css';
import '../styles/dashboardQuestionSettings.css';
import Empty from "../utils/Empty";
import Loading from "../utils/Loading";
import Avatar from "../utils/Avatar";
import TabOrder from "../utils/TabOrder";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardQuestionSettings({Dialog, dialog, locale, configuration, width, toast, system, setSystem, teamtalk, navigation, setModel, setTeamtalk, setToast, messages, workspace, functions, setFunctions, setLabel}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [prompt, setPrompt] = useState(null);
    const [override, setOverride] = useState(null);
    const [personality, setPersonality] = useState(null);
    const [group, setGroup] = useState(null);
    const [voice, setVoice] = useState(null);
    const [avatar, setAvatar] = useState(null);
    const [name, setName] = useState(null);
    const [ai, setAi] = useState(null);
    const [usage, setUsage] = useState([]);
    const [summary, setSummary] = useState({});
    const [tab, setTab] = useState('general');
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);

    const DialogClose = useCallback(() => {
        Dialog({view: 'close'});
    }, [Dialog]);

    const Settings = () => {

        const message = {
            type: 'wss',
            path: 'conversation-settings',
            action: 'get',
            data: (!Empty(teamtalk) && teamtalk.id) ? {teamtalk: {id: teamtalk.id}} : {}
        };
        wsCall(message);
    }

    const CheckboxSystem = () => {
        if (system) {
            setSystem(false);
        } else {
            setSystem(true);
        }

        const message = {
            type: 'wss',
            path: 'conversation',
            action: 'get',
            data: {
                system: system ? false : true,
                rewind: false,
                error: false
            }
        };
        wsCall(message);
    }

    const ButtonClose = () => {
        if (settings.prompt !== prompt ||
            settings.promptOverride !== override ||
            settings.personality !== personality ||
            settings.voice !== voice ||
            settings.model !== ai ||
            settings.name !== name ||
            !avatar) {

            const message = {
                type: 'wss',
                path: 'conversation-settings',
                action: 'put',
                data: {
                    prompt: prompt,
                    promptOverride: override,
                    voice: voice,
                    personality: personality,
                    model: ai,
                    name: name,
                    teamtalk: (!Empty(teamtalk) && teamtalk.id) ? teamtalk : null,
                    tab: Empty(teamtalk) ? navigation.tab : null,
                    avatar: (!avatar || settings.voice !== voice || settings.personality !== personality || settings.promptOverride !== override) ? true : false
                }
            };
            wsCall(message);
        } else {
            DialogClose();
        }
    }

    const ButtonConversation = () => {
        confirm({
            title: locale.dashboardQuestionSettings.m,
            message: locale.dashboardQuestionSettings.q,
            okText: locale.dashboardQuestionSettings.o,
            cancelText: locale.dashboardQuestionSettings.p,
            callback: (res) => {
                if (res) {

                    const message = {
                        type: 'wss',
                        path: 'conversation-reset',
                        action: 'update',
                        data: {
                            teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id} : null,
                            tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                        }
                    };
                    wsCall(message);
                }
            }
        });
    }

    const ButtonWorkspace = () => {
        confirm({
            title: locale.dashboardQuestionSettings.n,
            message: locale.dashboardQuestionSettings.r,
            okText: locale.dashboardQuestionSettings.o,
            cancelText: locale.dashboardQuestionSettings.p,
            callback: (res) => {
                if (res) {

                    const message = {
                        type: 'wss',
                        path: 'workspace-reset',
                        action: 'update',
                        data: {
                            teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id} : null,
                            tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
                        }
                    };
                    wsCall(message);
                }
            }
        });
    }

    const SelectFunctions = data => {

        const message = {
            type: 'wss',
            path: 'conversation-function',
            action: 'update',
            data: {
                functions: data,
                teamtalk: (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null
            }
        };
        wsCall(message);
    }

    const SelectGroup = data => {
        setGroup(data);
        const personalityItem = configuration.mobi.personalities[data].find(item => item.default);

        if (personalityItem) {
            setPersonality(personalityItem.value);
        } else {
            setPersonality(configuration.mobi.personalities[data].sort((a, b) => a.text.localeCompare(b.text, locale))[0].value);
        }
    }

    const ListItem = data => {
        const id = data.item.model;

        return <li data-id={id} className="cs-dashboard-question-settings-list-multi" >
            <div className="mbsc-row cs-dashboard-question-settings-list" >
                <div>
                    <div className="mbsc-txt-muted">
                        <span className="mbsc-bold">{data.item.short}</span>
                        <span className="mbsc-bold cs-dashboard-question-settings-button-nav">&nbsp;|&nbsp;</span>
                        {data.item.tokensTotal ?
                            <>{data.item.tokensTotal.toLocaleString('en-US')} {locale.dashboardQuestionSettings.z}</>
                            :
                            <>{data.item.itemOutput.toLocaleString('en-US')} {data.item.itemOutput === 1 ? locale.dashboardQuestionSettings.ac : locale.dashboardQuestionSettings.ab}</>
                        }
                        <span className="mbsc-bold cs-dashboard-question-settings-button-nav">&nbsp;|&nbsp;</span>
                        {data.item.percentage}%
                    </div>
                </div>
            </div>
        </li>;
    }

    const GetConversationSettings = useCallback(data => {
        if (data.prompt) {
            setPrompt(data.prompt);
        }
        if (data.promptOverride === true || data.promptOverride === false) {
            setOverride(data.promptOverride);
        }
        if (data.personality) {
            setPersonality(data.personality);
            let groupItem = null;

            for (const [key, array] of Object.entries(configuration.mobi.personalities)) {
                const match = array.find((item) => item.value === data.personality);
                if (match) groupItem = key;
            }

            setGroup(groupItem);
        }
        if (data.voice) {
            setVoice(data.voice);
        }
        if (data.avatar) {
            setAvatar(data.avatar);
        } else {
            setAvatar(null);
        }
        if (data.model) {
            setAi(data.model);
        }
        if (data.usage) {
            setUsage(data.usage);
        }
        if (data.summary) {
            setSummary(data.summary);
        }
        if (data.name) {
            setName(data.name);
        }
        setSettings(data);
        setLoading(false);
    }, [navigation, configuration.mobi.personalities]);

    const PutConversationSettings = useCallback(data => {
        if (data.model) {
            setModel(data.model);
        }
        if (data.teamtalkData) {
            setTeamtalk(data.teamtalkData);
        }
        if (data.name) {
            setLabel(data.name);
        }
        setToast({message: locale.dashboardQuestionSettings.l, color: 'info', display: 'bottom', duration: 1000});
        DialogClose();
    }, [Dialog, dialog.view, DialogClose, locale.dashboardQuestionSettings.l]);

    const UpdateConversationFunction = useCallback(data => {
        if (data.toast) {
            setToast({message: locale.dashboardQuestionSettings.l, color: 'info', display: 'bottom', duration: 1000});
        }
        if (data.functions) {
            setFunctions(data.functions);
        }
    }, [locale.dashboardQuestionSettings.l]);

    useEffect(() => {
        if (wsResponse &&
            !Empty(wsResponse) &&
            wsResponse.action === 'update' &&
            wsResponse.path === 'conversation-function' &&
            ((Empty(teamtalk) && !wsResponse.data.teamtalk) ||
                (!Empty(teamtalk) && wsResponse.data.teamtalk && teamtalk.id === wsResponse.data.teamtalk))) {
            UpdateConversationFunction(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, UpdateConversationFunction, setWsResponse, teamtalk]);

    useEffect(() => {
        if (wsResponse &&
            !Empty(wsResponse) &&
            wsResponse.action === 'put' &&
            wsResponse.path === 'conversation-settings' &&
            ((Empty(teamtalk) && !wsResponse.data.teamtalk) ||
                (!Empty(teamtalk) && wsResponse.data.teamtalk && teamtalk.id === wsResponse.data.teamtalk))) {
            PutConversationSettings(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, PutConversationSettings, setWsResponse, teamtalk]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'get' && wsResponse.path === 'conversation-settings') {
            GetConversationSettings(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, GetConversationSettings, setWsResponse]);

    useEffect(() => {
        Settings();
    }, []);

    return (
        <Popup className="cs-dashboard-question-settings-popup" maxHeight={750} closeOnOverlayClick={false} closeOnEsc={false} scrollLock={false} display="center" width="600" buttons={[]} isOpen={dialog.view === 'dashboardQuestionSettings'} onClose={DialogClose}>
            <div className="mbsc-grid cs-dashboard-question-settings-header-col">
                <div className="mbsc-row cs-dashboard-question-settings-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-dashboard-question-settings-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-dashboard-question-settings-header-col mbsc-align-center" : "mbsc-col cs-dashboard-question-settings-header-col"} >
                        <Button className="cs-dashboard-question-settings-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {Empty(teamtalk) ? locale.dashboardQuestionSettings.a : locale.dashboardQuestionSettings.i}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-dashboard-question-settings-header-col mbsc-align-right">
                        <Button color="primary" variant="flat" className="mbsc-bold cs-dashboard-question-settings-close-button" onClick={() => ButtonClose()} >
                            &nbsp;<FontAwesomeIcon className="cs-dashboard-question-settings-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            {loading &&
                <Loading />
            }
            {!loading &&
                <div className="mbsc-grid cs-dashboard-question-settings-header-col">
                    <div className="mbsc-row cs-dashboard-question-settings-header-row mbsc-justify-content-center">
                        <div style={{backgroundImage: Avatar({avatar, voice, configuration})}} className="cs-dashboard-question-settings-avatar" />
                    </div>
                </div>
            }
            {!loading &&
                <TabNav theme="mobiscroll" themeVariant="light" display='inline' className="cs-dashboard-question-settings-nav-tab" >
                    <NavItem selected={tab === 'general'} onClick={() => tab !== 'general' && setTab('general')} >
                        <span className={tab === 'general' ? 'mbsc-bold cs-dashboard-question-settings-button-nav' : ''} >{locale.dashboardQuestionSettings.s}</span>
                    </NavItem>
                    <NavItem selected={tab === 'usage'} onClick={() => tab !== 'usage' && setTab('usage')} >
                        <span className={tab === 'usage' ? 'mbsc-bold cs-dashboard-question-settings-button-nav' : ''} >{locale.dashboardQuestionSettings.x}</span>
                    </NavItem>
                    <NavItem selected={tab === 'advanced'} onClick={() => tab !== 'advanced' && setTab('advanced')} >
                        <span className={tab === 'advanced' ? 'mbsc-bold cs-dashboard-question-settings-button-nav' : ''} >{locale.dashboardQuestionSettings.t}</span>
                    </NavItem>
                </TabNav>
            }
            {tab === 'general' && !loading &&
                <div className="mbsc-form-group">
                    <Input
                        inputStyle="underline"
                        label={!Empty(teamtalk) ? locale.dashboardQuestionSettings.j : locale.dashboardQuestionSettings.k}
                        labelStyle="floating"
                        type="text"
                        name="name"
                        value={name}
                        onChange={ev => setName(ev.target.value)}
                    />
                    <div className="mbsc-form-group">
                        <Select
                            disabled={override}
                            animation="slide-down"
                            inputStyle="underline"
                            label={locale.dashboardQuestionSettings.w}
                            labelStyle="floating"
                            touchUi={false}
                            rows={configuration.mobi.personalitiesGroups.length}
                            display="anchored"
                            data={configuration.mobi.personalitiesGroups}
                            value={group}
                            onChange={args => SelectGroup(args.value)}
                        />
                        <Select
                            disabled={override}
                            animation="slide-down"
                            inputStyle="underline"
                            label={locale.dashboardQuestionSettings.g}
                            labelStyle="floating"
                            touchUi={false}
                            rows={group ? configuration.mobi.personalities[group].length : 0}
                            display="anchored"
                            data={group ? configuration.mobi.personalities[group].sort((a, b) => a.text.localeCompare(b.text, locale)) : []}
                            value={personality}
                            onChange={args => setPersonality(args.value)}
                        />
                    </div>
                    <Select
                        animation="slide-down"
                        inputStyle="underline"
                        label={locale.dashboardQuestionSettings.f}
                        labelStyle="floating"
                        touchUi={false}
                        rows={configuration.mobi.voice.length}
                        display="anchored"
                        data={configuration.mobi.voice}
                        value={voice}
                        onChange={args => setVoice(args.value)}
                    />
                    {configuration.ui.dashboard.model &&
                        <Select
                            animation="slide-down"
                            inputStyle="underline"
                            dropdown={false}
                            label={locale.dashboardQuestionSettings.h}
                            labelStyle="floating"
                            disabled={!Empty(toast) || system}
                            rows={configuration.mobi.model.length}
                            display="anchored"
                            touchUi={false}
                            data={configuration.mobi.model}
                            value={ai}
                            onChange={args => setAi(args.value)}
                        />
                    }
                </div>
            }
            {tab === 'usage' && !loading &&
                <>
                    <div className="cs-dashboard-question-settings-helper">
                        <p>{locale.dashboardQuestionSettings.y}</p>
                    </div>
                    <div className="cs-dashboard-question-settings-scroll">
                        <Listview
                            theme="ios"
                            themeVariant="light"
                            select="single"
                            itemType={ListItem}
                            data={usage}
                        />
                    </div>
                    <div className="mbsc-button-group-block cs-dashboard-question-settings-summary-block">
                        <Button color="primary" variant="flat" className="cs-dashboard-question-settings-button-summary mbsc-txt-muted" >
                            {summary.itemOutput !== 0 &&
                                <>
                                    <span className="mbsc-bold" >{locale.dashboardQuestionSettings.ab}:&nbsp;{summary.itemOutput.toLocaleString('en-US')}</span>
                                    <span className="mbsc-bold" >&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                                </>
                            }
                            <span className="mbsc-bold" >{locale.dashboardQuestionSettings.z}:&nbsp;{summary.tokensTotal.toLocaleString('en-US')}</span>
                            <span className="mbsc-bold" >&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                            <span className="mbsc-bold" >{locale.dashboardQuestionSettings.aa}:&nbsp;${summary.tokensTotalCost.toFixed(2)}</span>
                        </Button>
                    </div>
                </>
            }
            {tab === 'advanced' && !loading &&
                <div className="mbsc-form-group">
                    <div className="cs-dashboard-question-settings-helper">
                        <p>{locale.dashboardQuestionSettings.d}</p>
                    </div>
                    <div className="cs-dashboard-question-settings-textarea">
                        <Textarea
                            inputStyle="underline"
                            labelStyle="floating"
                            rows={3}
                            value={prompt}
                            onChange={(ev) => setPrompt(ev.target.value)}
                        />
                    </div>
                    {Empty(teamtalk) && configuration.ui.dashboard.override &&
                        <div className="mbsc-grid cs-dashboard-question-settings-main">
                            <Checkbox
                                cssClass="cs-dashboard-question-settings-checkbox mbsc-bold"
                                color="info"
                                position="end"
                                label={locale.dashboardQuestionSettings.c}
                                checked={override}
                                onChange={(ev) => setOverride(ev.target.checked)}
                            />
                        </div>
                    }
                    {Empty(teamtalk) && configuration.ui.dashboard.functions && configuration.mobi.functions.length !== 0 &&
                        <div className="cs-dashboard-question-settings-helper">
                            <p>{locale.dashboardQuestionSettings.v}</p>
                        </div>
                    }
                    {Empty(teamtalk) && configuration.ui.dashboard.functions && configuration.mobi.functions.length !== 0 &&
                        <Select
                        animation="slide-down"
                        inputStyle="underline"
                        dropdown={false}
                        placeholder={locale.dashboardQuestionSettings.u}
                        labelStyle="floating"
                        touchUi={false}
                        rows={3}
                        display="inline"
                        selectMultiple={true}
                        value={functions}
                        data={configuration.mobi.functions}
                        onChange={args => SelectFunctions(args.value)}
                        />
                    }
                    {Empty(teamtalk) && configuration.ui.dashboard.system &&
                        <div className="cs-dashboard-question-settings-helper">
                            <p>{locale.dashboardQuestionSettings.e}</p>
                        </div>
                    }
                    {Empty(teamtalk) && configuration.ui.dashboard.system &&
                        <div className="mbsc-grid cs-dashboard-question-settings-main">
                            <Checkbox
                                cssClass="cs-dashboard-question-settings-checkbox mbsc-bold"
                                color="info"
                                position="end"
                                label={locale.dashboardQuestionSettings.b}
                                checked={system}
                                onChange={(ev) => CheckboxSystem(ev.target.checked)}
                            />
                        </div>
                    }
                </div>
            }
            <div className="mbsc-button-group-justified cs-dashboard-question-settings-nav-buttons">
                <Button disabled={messages === 0} color="primary" variant="flat" className="mbsc-bold cs-dashboard-question-settings-nav-button" onClick={() => ButtonConversation()} >
                    {locale.dashboardQuestionSettings.m}
                </Button>
                <Button disabled={workspace === 0} color="primary" variant="flat" className="mbsc-bold cs-dashboard-question-settings-nav-button" onClick={() => ButtonWorkspace()} >
                    {locale.dashboardQuestionSettings.n}
                </Button>
            </div>
        </Popup>
    );
}

export default DashboardQuestionSettings;
